import {
  MediaControlBar,
  MediaController,
  MediaFullscreenButton,
  MediaMuteButton,
  MediaPlayButton,
  MediaSeekBackwardButton,
  MediaSeekForwardButton,
  MediaTimeDisplay,
  MediaTimeRange,
  MediaVolumeRange,
} from "media-chrome/react";

import "youtube-video-element";
import { cn } from "../../lib/utils";

// 🎨 Theme variables
const variables = {
  "--media-primary-color": "var(--web-primary)",
  "--media-secondary-color": "var(--background)",
  "--media-text-color": "#fff",
  "--media-background-color": "var(--background)",
  "--media-control-hover-background": "var(--accent)",
  "--media-font-family": "var(--font-sans)",
  "--media-live-button-icon-color": "var(--muted-foreground)",
  "--media-live-button-indicator-color": "var(--destructive)",
  "--media-range-track-background": "hsl(var(--border))",
  "--media-tooltip-background-color": "var(--web-primary)",
  "--media-preview-time-background": "var(--web-primary)"
};

// 🚀 Detect YouTube URL
const extractYouTubeID = (url) => {
  if (!url) return null;

  const ytMatch = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );

  return ytMatch ? ytMatch[1] : null;
};

export const VideoPlayer = ({ style, ...props }) => (
  <MediaController
  fullscreenelement="wrapper"
    style={{
      ...variables,
      ...style,
    }}
    {...props}
  />
);

export const VideoPlayerControlBar = (props) => <MediaControlBar {...props} className="bg-white" />;

export const VideoPlayerTimeRange = ({ className, ...props }) => (
  <MediaTimeRange className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerTimeDisplay = ({ className, ...props }) => (
  <MediaTimeDisplay className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerVolumeRange = ({ className, ...props }) => (
  <MediaVolumeRange className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerPlayButton = ({ className, ...props }) => (
  <MediaPlayButton className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerSeekBackwardButton = ({ className, ...props }) => (
  <MediaSeekBackwardButton className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerSeekForwardButton = ({ className, ...props }) => (
  <MediaSeekForwardButton className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerMuteButton = ({ className, ...props }) => (
  <MediaMuteButton className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerFullscreenButton = ({ className, ...props }) => (
  <MediaFullscreenButton className={cn("p-2.5", className)} {...props} />
);

export const VideoPlayerContent = ({ className, ...props }) => {
  const youtubeId = extractYouTubeID(props?.src);
  return (
    <>
      {/* 🎥 If YouTube link → use YouTube provider */}
      {youtubeId ? (
        // <media-youtube
        //   slot="media"
        //   videoid={youtubeId}
        // ></media-youtube>
        <youtube-video
          slot="media"
          controls={false}
          className={cn("mt-0 mb-0", className)}
          {...props}
        ></youtube-video>
      ) : (
        /* 🎞 Normal video source */
        <video
          slot="media"
          controls={false}
          className={cn("mt-0 mb-0", className)}
          {...props}
        />
      )}
    </>
  );
};
